import React, { useState } from 'react';

/**
 * Bannière de consentement cookies (CNIL).
 * Gère le pixel Meta : révoqué par défaut dans index.html, accordé ici.
 * Choix stocké dans localStorage ('granted' / 'denied') — la bannière
 * ne réapparaît plus une fois le choix fait.
 */
const ConsentBanner = () => {
  const [choice, setChoice] = useState(
    () => localStorage.getItem('ar_cookie_consent')
  );

  if (choice) return null;

  const accept = () => {
    localStorage.setItem('ar_cookie_consent', 'granted');
    if (window.fbq) {
      window.fbq('consent', 'grant');
    }
    setChoice('granted');
  };

  const refuse = () => {
    localStorage.setItem('ar_cookie_consent', 'denied');
    setChoice('denied');
  };

  return (
    <div
      role="dialog"
      aria-label="Consentement aux cookies"
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg p-4"
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-3">
        <p className="text-sm text-gray-700 flex-1">
          Nous utilisons des cookies pour mesurer l'audience et améliorer le site.
          Vous pouvez refuser : le site fonctionne pareil.{' '}
          <a href="/confidentialite" className="underline text-blue-700">En savoir plus</a>
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            type="button"
            onClick={refuse}
            className="px-4 py-2 text-sm rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50"
          >
            Refuser
          </button>
          <button
            type="button"
            onClick={accept}
            className="px-4 py-2 text-sm rounded-lg text-white font-semibold"
            style={{ backgroundColor: '#1e3a8a' }}
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
